import React, {useEffect} from 'react'
import actions from "../actions/addCreditCard"
import { connect } from 'react-redux'
import {string, shape, bool, func} from "prop-types"
import CreditCardComponent from "../components/AddCreditCard"

const Container = props => {
  useEffect(() => {
    const {match, getDeposit} = props
    const {code} = match.params
    getDeposit(code)
  }, [])

  return <CreditCardComponent {...props}/>
}

Container.propTypes = {
  match: shape({
    params: shape({
      code: string
    }).isRequired
  }).isRequired,
  code: string.isRequired,
  loadingDeposit: bool.isRequired,
  loadingCard: bool.isRequired,
  number: string,
  expiry: string,
  cvc: string,
  cardholderName: string,
  documentType: string.isRequired,
  documentNumber: string,
  type: string,
  errorDeposit: string,
  error: string,
  deposit: shape({}).isRequired,
  completed: bool.isRequired,
  success: bool.isRequired,
  getDeposit: func.isRequired,
  setCardNumber: func.isRequired,
  setCardExpiry: func.isRequired,
  setCardCVC: func.isRequired,
  setCardholderName: func.isRequired,
  setDocumentType: func.isRequired,
  setDocumentNumber: func.isRequired,
  setCardType: func.isRequired,
  saveCard: func.isRequired,
}

const mapStateToProps = state => state.ui.addCreditCard.addCreditCard

const mapDispatchToProps = dispatch => {
  return {
    getDeposit: code => dispatch(actions.getDeposit(code)),
    setCardNumber: number => dispatch(actions.setCardNumber(number)),
    setCardExpiry: expiry => dispatch(actions.setCardExpiry(expiry)),
    setCardCVC: cvc => dispatch(actions.setCardCVC(cvc)),
    setCardholderName: cardholderName => dispatch(actions.setCardholderName(cardholderName)),
    setDocumentType: documentType => dispatch(actions.setDocumentType(documentType)),
    setDocumentNumber: documentNumber => dispatch(actions.setDocumentNumber(documentNumber)),
    setCardType: type => dispatch(actions.setCardType(type)),
    saveCard: () => dispatch(actions.saveCard()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)


// WEBPACK FOOTER //
// ./src/sections/addCreditCard/containers/AddCreditCard.js